import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {Home} from "../components/Home";
// import TourPackages from "../pages/TourPackages";
// import PackageDetails from "../pages/PackageDetails";
// import NotFound from "../pages/NotFound";
import {NavBar} from "../components/navbar";
import {Footer} from "../components/footer";
import HampiOneDayPackage from "../components/pages/hampi-tour-package";
import BookingSummary from "../components/bookingSummary/TourPackageSummary";
import PaymentOptions from "../components/PaymentOptionScreen";
import PaymentProcessing from "../components/PaymentOptionScreen/PaymentProcessing";
import BookingStatus from "../components/bookingStatus";
import HampiHalfDayPackage from "../components/pages/hampi-half-day-package";
import PackageScreen from "./PackageRoute";
import PackageItinerary from "../components/PackageItinerary";
import BookTour from "../components/booking/bookTour";
import TripList from "../components/profile/TripList";
import TripDetails from "../components/profile/TripDetails";
import { PackageLists } from "../components/packages/PackageLists";
import Services from "../components/services/Services";
import RefundPolicy from "../components/policies/RefundPolicy";
import PricingPolicy from "../components/policies/PricingPolicy";
import TermsAndConditions from "../components/policies/TermsAndCondition";
import PrivacyPolicy from "../components/policies/PrivacyPolicy";
import ContactPage from "../components/contact/ContactPage";
import UserDataDeletionPage from "../components/policies/UserDataDeletion";

const AppRoutes = () => {
  return (
    <Router>
      {/* Common Navbar */}
      <NavBar />

      {/* Define Routes */}
      <Routes>
        <Route path="/" element={<PackageLists />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* <Route path="/packages/:hampi" element={<HampiOneDayPackage />} />
        <Route path="/packages/:hampi" element={<HampiHalfDayPackage/>}/> */}
        {/* <Route path ='/packages/:hampi' element={<PackageScreen/>}/> */}
        <Route path='/tour-packages' element={<PackageLists/>}/>
        {/* <Route path="/package-details" element={<PackageItinerary/>}/> */}
        <Route path="/packages/:slug" element={<PackageItinerary />} />
        <Route path="/tour-package-booking" element={<BookTour/>}/>
        <Route path="/booking-summary" element={<BookingSummary />} />
        <Route path="/payment-options" element={<PaymentOptions/>}/>
        <Route path="/payment-processing" element={<PaymentProcessing/>}/>
        <Route path='/booking-status' element={<BookingStatus/>}/>
        <Route path='/trips' element={<TripList/>}/>
        <Route path="/trip-details/:tripId" element={<TripDetails />} />
        <Route path="/services" element={<Services/>}/>
        <Route path="/RefundPolicy" element={<RefundPolicy/>} />
        <Route path="/PricingPolicy" element={<PricingPolicy/>}/>
        <Route path="/TermsandCond" element={<TermsAndConditions/>}/>
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy/>}/>
        <Route path="/UserDataDeletion" element={<UserDataDeletionPage/>}/>
         {/* <Route path="/packages/:slug" element={<PackageDetails />} /> */}
        {/* <Route path="*" element={<NotFound />} /> Catch-all route */}
      </Routes>

      {/* Common Footer */}
     
    </Router>
  );
};

export default AppRoutes;
